"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialLinksProperty = exports.socialLinksPropertyDefinition = void 0;
exports.socialLinksPropertyDefinition = {
    view: { label: 'Social links' },
    constraints: [
        {
            name: 'providers',
            argument: [
                'Facebook',
                'Instagram',
                'ScribbleLive',
                'Snapchat',
                'SoundCloud',
                'Spotify',
                'TikTok',
                'Twitch',
                'Twitter',
                'YouTube',
            ],
        },
    ],
    type: 'service',
    multiple: true,
    name: 'social-links',
};
const isSocialLinksProperty = (prop) => {
    return prop.name === exports.socialLinksPropertyDefinition.name;
};
exports.isSocialLinksProperty = isSocialLinksProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLWxpbmtzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc29jaWFsLWxpbmtzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGNBQWMsRUFBRTtJQUMvQixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRTtnQkFDUixVQUFVO2dCQUNWLFdBQVc7Z0JBQ1gsY0FBYztnQkFDZCxVQUFVO2dCQUNWLFlBQVk7Z0JBQ1osU0FBUztnQkFDVCxRQUFRO2dCQUNSLFFBQVE7Z0JBQ1IsU0FBUztnQkFDVCxTQUFTO2FBQ1Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxjQUFjO0NBQ1csQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9